import { create } from 'zustand'
import { persist } from 'zustand/middleware'

const INITIAL_STATE = {
  isExpanded: true,
  isMobileOpen: false,
}

interface SidebarStore {
  isExpanded: boolean
  isMobileOpen: boolean
  toggle: () => void
  setExpanded: (expanded: boolean) => void
  setMobileOpen: (open: boolean) => void
  closeMobile: () => void
  reset: () => void
}

export const useSidebarStore = create<SidebarStore>()(
  persist(
    (set) => ({
      ...INITIAL_STATE,
      toggle: () => set((state) => ({ isExpanded: !state.isExpanded })),
      setExpanded: (expanded) => set({ isExpanded: expanded }),
      setMobileOpen: (open) => set({ isMobileOpen: open }),
      closeMobile: () => set({ isMobileOpen: false }),
      reset: () => set(INITIAL_STATE),
    }),
    {
      name: 'sidebar-state',
      partialize: (state) => ({ isExpanded: state.isExpanded }),
    }
  )
)

// Função utilitária para limpar o estado persistido do sidebar
export function clearSidebarStorage() {
  localStorage.removeItem('sidebar-state')
}
